/* eslint-disable react/no-this-in-sfc */
import React, { useEffect } from 'react';
import { useSet } from 'react-use';
import { EmptyState } from '../../../../../CommonComponents/OPL/AsyncStates/EmptyState/EmptyState';
import { ErrorState } from '../../../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { LineChartLoading } from '../../../../../CommonComponents/OPL/charts/LineChart/LineChart.loading';
import { useIsEmbeddedMobile } from '../../../../../_hooks/useIsEmbeddedMobile';
import { usePerformanceVsBenchmark } from '../../../../hooks/usePerformanceVsBenchmark';
import { PerformanceVsBenchmarkChartContent } from '../PerformanceVsBenchmarkChartContent/PerformanceVsBenchmarkChartContent';

const CHART_HEIGHT = 340;

interface ContentProps {
  setSelectedDate: (date: string | null) => void;
}

export const PerformanceVsBenchmarkChartWrapper = ({ setSelectedDate }: ContentProps) => {
  const { isFetching, isError, refetch, data } = usePerformanceVsBenchmark();

  const isEmbeddedMobile = useIsEmbeddedMobile();

  const [
    ,
    { has: isBenchmarkHidden, toggle: toggleBenchmarkVisibility, reset: resetHiddenBenchmarks },
  ] = useSet();

  useEffect(() => {
    resetHiddenBenchmarks();
  }, [isEmbeddedMobile, resetHiddenBenchmarks]);

  if (isFetching) {
    return (
      <LineChartLoading
        chartHeight={isEmbeddedMobile ? CHART_HEIGHT : 280}
        showLegend={!isEmbeddedMobile}
        mb="32"
      />
    );
  }

  if (isError) {
    return (
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        py={isEmbeddedMobile ? '48' : undefined}
        height="100%"
      >
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  if (data.length === 0) {
    return (
      <Box
        height="100%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        py={isEmbeddedMobile ? '24' : undefined}
      >
        <EmptyState />
      </Box>
    );
  }

  return (
    <PerformanceVsBenchmarkChartContent
      setSelectedDate={setSelectedDate}
      isBenchmarkHidden={isBenchmarkHidden}
      toggleBenchmarkVisibility={toggleBenchmarkVisibility}
      data={data}
    />
  );
};
